<template>
  <v-container class="confirm-module py-12 px-5 px-md-7 pa-md-20">
    <v-card-title
      class="display-1 font-weight-bold pa-0 mb-8 letter-spacing-normal"
    >
      Confirmation
      <v-progress-linear v-if="fetchingSummary" indeterminate />
    </v-card-title>

    <v-row
      v-if="(!sightings || !report.length) && !fetchingSummary"
      class="justify-lg-space-between align-center"
    >
      No sightings reported!
    </v-row>
    <v-card-text>
      <v-row
        v-if="fetchingSummary"
        class="justify-lg-space-between align-center"
      >
        <v-skeleton-loader
          :loading="true"
          height="250"
          type="table-thead, table-tbody, table-tfoot"
        />
      </v-row>
      <v-row
        v-else
        v-for="(summary, index) in report"
        :key="index"
        class="justify-lg-space-between align-center"
      >
        <v-col sm="12">
          <v-row
            class="flex-column flex-md-row p-r justify-lg-space-between align-center"
          >
            <v-col class="pa-0">
              <v-card-title
                class="py-0 title font-weight-bold letter-spacing-normal"
              >
                {{ getSummaryTitle(summary.member) }}
              </v-card-title>
            </v-col>
            <v-col v-if="!group.checked_out" class="text-md-right pa-0">
              <v-btn
                text
                class="pa-0 primary--text title font-weight-bold letter-spacing-normal edit-link"
                @click="edit(summary.editStep)"
              >
                Edit
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="justify-lg-space-between align-center c-table-wrap">
            <v-col class="pa-0">
              <v-data-table
                :headers="headers"
                :items="summary.sightings"
                v-bind="
                  summary.sightings.length > 5
                    ? { itemsPerPage: 5 }
                    : { hideDefaultFooter: true }
                "
                class="border-radius-0 v-data-table-1 v-data-table-1--style3"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-container>
</template>

<script>
export default {
  name: 'Confirm',
  props: {
    group: {
      type: Object,
      required: true,
    },
    sightings: {
      type: Object,
      required: true,
    },
    fetchingSummary: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Species',
          align: 'left',
          sortable: false,
          value: 'species.name',
        },
        { text: 'Count', value: 'count', width: 200 },
      ],
      sightingsData: this.sightings,
    };
  },
  computed: {
    report() {
      let self = this;
      let report = [];
      if (!self.sightingsData || !self.sightingsData.attendees) {
        return [];
      }
      self.group.members.forEach((member, index) => {
        report.push({
          editStep: index + 2,
          member,
          sightings: self.sightingsData.attendees
            .filter((attendee) => attendee.member_id === member.id)
            .map((attendee) => {
              return {
                species_id: attendee.species_id,
                species: attendee.species,
                count: attendee.count,
              };
            }),
        });
      });
      return report;
    },
  },
  methods: {
    getSummaryTitle(member) {
      let name = member.first_name;
      if (name.endsWith('s')) {
        return `${name}' Sightings`;
      }
      return `${name}'s Sightings`;
    },
    edit(editStep) {
      this.$emit('edit', editStep);
    },
  },
};
</script>

<style scoped></style>
